<template>
  <div class="check-in-reward">
    <div class="check-in-reward__shell">
      <div class="check-in-reward__card" :style="{ backgroundImage: `url(${cardBgUrl})` }">
        <img :src="rabbitUrl" class="check-in-reward__rabbit" alt="" />

        <div class="check-in-reward__header">
          <div class="check-in-reward__header-main">
            <h2 v-if="isNotSigned" class="check-in-reward__title">
              CHECK-IN DIARIO, PREMIOS DIARIOS!
            </h2>
            <template v-else>
              <h2 class="check-in-reward__title">{{ checkInState.signCount }} CHECK-INS</h2>
              <p class="check-in-reward__subtitle">
                Bônus total acumulado:
                <span class="check-in-reward__subtitle-amount">
                  R$ {{ formatBonus(accumulatedBonus) }}
                </span>
              </p>
            </template>
          </div>
          <p class="check-in-reward__tip">
            <template v-if="isCompleted">
              Deposite apenas
              <span class="check-in-reward__tip-highlight">
                R$ {{ formatBonus(unlockRechargeAmount) }}
              </span>
              e leve todos os prêmios!
            </template>
            <template v-else>
              Faça 
              <span class="check-in-reward__tip-highlight">7 check-ins</span>
              e resgate o prêmio acumulado!
            </template>
          </p>
        </div>

        <div class="check-in-reward__grid">
          <div
            v-for="item in dailyRewards"
            :key="item.day"
            class="check-in-reward__item"
            :class="{
              'check-in-reward__item--day7': item.day === dailyRewards.length,
              'check-in-reward__item--collected': isDayCollected(item.day),
            }"
          >
            <div class="check-in-reward__item-body">
              <span class="check-in-reward__day-label">Dia {{ item.day }}</span>
              <img :src="coinUrl" class="check-in-reward__coin" alt="" />
              <span class="check-in-reward__amount">R$ {{ item.amount }}</span>
            </div>
            <span v-if="isDayCollected(item.day)" class="check-in-reward__collected">Coletado</span>
          </div>
        </div>

        <button
          type="button"
          class="check-in-reward__action"
          :class="{
            'check-in-reward__action--disabled': isActionDisabled && !isNeonLoading,
            'check-in-reward__action--neon-loading': isNeonLoading,
          }"
          :disabled="isActionDisabled"
          @click="handleActionClick"
        >
          <span
            v-if="isActionLoading || isNeonLoading"
            class="check-in-reward__loading"
            aria-live="polite"
          >
            <span
              v-for="(ch, index) in loadingChars"
              :key="`${ch}-${index}`"
              class="check-in-reward__loading-char"
              :style="{ '--char-index': index }"
            >
              {{ ch }}
            </span>
          </span>
          <template v-else>
            {{ actionButtonText }}
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCheckInReward } from './js/index.js'

const emit = defineEmits([
  'open-recharge',
  'open-deposit',
  'sign-success',
  'request-state-change',
])

const {
  checkInState,
  cardBgUrl,
  rabbitUrl,
  coinUrl,
  dailyRewards,
  isNotSigned,
  isCompleted,
  accumulatedBonus,
  unlockRechargeAmount,
  formatBonus,
  isDayCollected,
  actionButtonText,
  isActionDisabled,
  isActionLoading,
  isNeonLoading,
  loadingChars,
  handleActionClick,
  fetchInfo,
  applyCheckInInfo,
  stopNeonLoading,
} = useCheckInReward(emit)

defineExpose({
  fetchInfo,
  applyCheckInInfo,
  stopNeonLoading,
})
</script>

<style lang="less" scoped src="./css/index.less"></style>
